import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import useLocalization from '../../hooks/useLocalization';

type PhoneNumberInputProps<T extends FieldValues, TTransformedValues = T> = Omit<TextFieldProps, 'name'> & {
  name: Path<T>;
  control: Control<T, unknown, TTransformedValues>;
};

const PhoneNumberInput = <T extends FieldValues, TTransformedValues = T>({
  name,
  control,
  ...textFieldProps
}: PhoneNumberInputProps<T, TTransformedValues>) => {
  const { t } = useLocalization();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          onChange={field.onChange}
          fullWidth
          label={t('phoneNumber')}
          type='tel'
          inputMode='tel'
          {...textFieldProps}
          slotProps={{
            ...textFieldProps.slotProps,
            inputLabel: { ...textFieldProps.slotProps?.inputLabel, shrink: true },
          }}
        />
      )}
    />
  );
};

export default PhoneNumberInput;
